import React from "react";
import AwsDashboard from "./AwsDashboard";
import GithubDashboard from "./GithubDashboard";
import GitLabDashboard from "./GitlabDashboard";
import JiraDashboard from "./JiraDashboard";
import MongodbDashboard from "./MongodbDashboard";
import AzureDashboard from "./AzureDashboard";
import OdooDashboard from "./OdooDashboard";

const ConnectorDashboards = ({ data }) => {
  const connector = data?.connector?.name?.toLowerCase();

  const formatLastConnected = (iso) => {
    if (!iso) return "Recently";

    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  switch (connector) {
    case "aws":
      return (
        <AwsDashboard data={data} formatLastConnected={formatLastConnected} />
      );
    case "github":
      return (
        <GithubDashboard
          data={data}
          formatLastConnected={formatLastConnected}
        />
      );
    case "gitlab":
      return (
        <GitLabDashboard
          data={data}
          formatLastConnected={formatLastConnected}
        />
      );
    case "jira":
      return (
        <JiraDashboard data={data} formatLastConnected={formatLastConnected} />
      );
    case "mongodb":
      return (
        <MongodbDashboard
          data={data}
          formatLastConnected={formatLastConnected}
        />
      );
    case "microsoft azure":
      return (
        <AzureDashboard data={data} formatLastConnected={formatLastConnected} />
      );
    case "odoo":
      return (
        <OdooDashboard data={data} formatLastConnected={formatLastConnected} />
      );
    default:
      return <div>No data available</div>;
  }
};

export default ConnectorDashboards;
